/*
 * Hindrar att en produkt läggs i varukorgen innan storlek valts.
 *
 * Dawn förväljer alltid första tillgängliga varianten. På strumpor leder det
 * till felköp: kunden ser en köpknapp, trycker, och får en storlek hen aldrig
 * valde. Den här filen kopplar loss köpknappen tills ett aktivt val gjorts.
 *
 * Dawns egen variantlogik lämnas orörd — den sköter pris, bild och lagerstatus
 * som vanligt så fort ett val registrerats.
 */

class SsSizeGuard extends HTMLElement {
  connectedCallback() {
    this.fieldset = this.querySelector('[data-ss-size-option]');
    if (!this.fieldset) return;

    this.form = this.closest('product-info')?.querySelector('form[data-type="add-to-cart-form"]');
    this.submit = this.form?.querySelector('[name="add"]');
    this.errorEl = this.fieldset.querySelector('[data-ss-choose-error]');
    if (!this.submit) return;

    this.radios = Array.from(this.fieldset.querySelectorAll('input[type="radio"]'));
    if (this.radios.length === 0) return;

    // Ett val via URL (?variant=) räknas som medvetet och behålls.
    const preselectedByUrl = new URLSearchParams(window.location.search).has('variant');
    this.chosen = preselectedByUrl && this.radios.some((r) => r.checked);

    if (!this.chosen) {
      this.radios.forEach((radio) => {
        radio.checked = false;
      });
      this.lock();
    }

    this.fieldset.addEventListener('change', () => this.unlock());

    // Klick på en låst knapp ska förklara varför, inte bara vara död.
    this.submit.addEventListener(
      'click',
      (event) => {
        if (this.chosen) return;
        event.preventDefault();
        event.stopPropagation();
        this.showError();
      },
      true
    );
  }

  lock() {
    this.submit.setAttribute('aria-disabled', 'true');
    this.submit.classList.add('ss-locked');
    this.originalLabel ??= this.submitText?.textContent;
    if (this.submitText) this.submitText.textContent = this.chooseLabel;
  }

  unlock() {
    this.chosen = true;
    this.submit.removeAttribute('aria-disabled');
    this.submit.classList.remove('ss-locked');
    if (this.submitText && this.originalLabel) this.submitText.textContent = this.originalLabel;
    this.hideError();
  }

  showError() {
    if (!this.errorEl) return;
    this.errorEl.hidden = false;
    this.fieldset.classList.add('ss-size-picker--error');
    // Flytta fokus till första storleksknappen så tangentbordsanvändare
    // hamnar där valet faktiskt görs.
    this.radios[0]?.focus();
  }

  hideError() {
    if (!this.errorEl) return;
    this.errorEl.hidden = true;
    this.fieldset.classList.remove('ss-size-picker--error');
  }

  get submitText() {
    return this.submit?.querySelector('span:not(.visually-hidden)') ?? this.submit;
  }

  get chooseLabel() {
    return this.dataset.chooseLabel || 'Välj storlek';
  }
}

if (!customElements.get('ss-size-guard')) {
  customElements.define('ss-size-guard', SsSizeGuard);
}
